var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _HznText_instances, _HznText_isBlockStyle_get;
// class definition
import { LitElement } from '@horizon/base';
import { unsafeStatic, html } from '@horizon/base/static-html.js';
import { property } from '@horizon/base/decorators.js';
import { classMap } from '@horizon/base/directives.js';
import TextStyles from './text.css.js';
import { BlockElements, InlineElements } from '../types.js';
/**
 *
 * @tag hzn-text
 * @tagname hzn-text
 * @summary A text component for adding and styling text
 */
export class HznText extends LitElement {
    constructor() {
        super(...arguments);
        _HznText_instances.add(this);
        /**
         * Sets whether the hzn-text host element should be `display: inline`. Defaults to `false`
         */
        this.inline = false;
        /**
         * Sets the variant/style of the text to be displayed
         * @playroomValues {'text' | 'caption' | 'callout' | 'eyebrow'}
         */
        this.variant = 'text';
        /**
         * Sets the font size of text within element
         * @playroomValues {'small' | 'base' | 'large'}
         */
        this.size = 'base';
        /**
         * Sets the color of text within element
         * @playroomValues {'body' | 'brand' | 'subdued' | 'critical' | 'caution' | 'positive' | 'info' | 'flagged' | 'interactive' | 'disabled' | 'inverse'}
         */
        this.tone = 'body';
        /**
         * Sets the font weight of text within element
         * @playroomValues {'base' | 'bold'}
         */
        this.weight = 'base';
        /**
         * Sets the text-align of text along the x-axis
         * @playroomValues {'left' | 'center' | 'right'}
         */
        this.align = 'left';
        /**
         * Sets the tag of the shadow element
         * @playroomValues {'span' | 'div' | 'sub' | 'sup' | 'p' | 'li'}
         */
        this.as = 'p';
        /**
         * Sets the line height of text within element
         * @playroomValues {'none' | 'xsmall' | 'small' | 'base' | 'large' | 'xlarge'}
         */
        this.lineHeight = 'base';
        /**
         * Truncates the text (This is...)
         */
        this.truncate = false;
    }
    render() {
        const classes = {
            'text-cont': true,
            'capsize': __classPrivateFieldGet(this, _HznText_instances, "a", _HznText_isBlockStyle_get)
        };
        const isValidAs = this.as ? [...InlineElements, ...BlockElements].includes(this.as) : false;
        // DONT FORMAT to add new lines. This component can be display:inline and the whitespace in it will be included.
        return html `<${unsafeStatic(this.as && isValidAs ? this.as : 'p')} class="${classMap(classes)}"><slot></slot></${unsafeStatic(this.as && isValidAs ? this.as : 'p')}>`;
    }
}
_HznText_instances = new WeakSet(), _HznText_isBlockStyle_get = function _HznText_isBlockStyle_get() {
    return [...BlockElements].includes(this.as) && !this.inline;
};
HznText.styles = [TextStyles];
__decorate([
    property({ type: Boolean, reflect: true })
], HznText.prototype, "inline", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznText.prototype, "variant", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznText.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznText.prototype, "tone", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznText.prototype, "weight", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznText.prototype, "align", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznText.prototype, "as", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'line-height' })
], HznText.prototype, "lineHeight", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HznText.prototype, "truncate", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznText.prototype, "on", void 0);
//# sourceMappingURL=text.js.map